import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import FilterPanel from './FilterPanel';

const MobileFilterDrawer = ({ isOpen, onClose, filters, onFilterChange, resultCount, onClearFilters }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-dropdown md:hidden">
      <div 
        className="fixed inset-0 bg-background/80 backdrop-blur-sm" 
        onClick={onClose}
      />
      
      <div className="fixed inset-y-0 right-0 w-full max-w-md bg-background shadow-elevation-5 overflow-y-auto">
        <div className="sticky top-0 bg-background border-b border-border p-4 flex items-center justify-between z-10">
          <h2 className="font-heading text-xl font-semibold text-foreground">
            Filters
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-md text-foreground hover:bg-muted transition-smooth"
            aria-label="Close filters"
          >
            <Icon name="X" size={24} strokeWidth={2} />
          </button>
        </div>

        <div className="p-4">
          <FilterPanel
            filters={filters}
            onFilterChange={onFilterChange}
            resultCount={resultCount}
            onClearFilters={onClearFilters}
          />
        </div>

        <div className="sticky bottom-0 bg-background border-t border-border p-4">
          <Button
            variant="default"
            size="lg"
            onClick={onClose}
            fullWidth
          >
            Show {resultCount} Results
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileFilterDrawer;